import { themeConWeb } from '@app/util/modernThemeConweb'
import {
  Box,
  Button,
  ClickAwayListener,
  Paper,
  Popper,
  Typography,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core'
import Dotdotdot from 'react-dotdotdot'
import { makeStyles } from '@material-ui/core/styles'
import { LocationOn, RadioButtonChecked, RadioButtonUnchecked } from '@material-ui/icons'
import React, { useState } from 'react'
import styled from 'styled-components'
import { eachDay, format, addDays } from 'date-fns'
import Dropdown from 'react-dropdown'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PersonIcon from '@material-ui/icons/Person'

import LocationSearchWithScripts from './LocationSearch'

const useStyles = makeStyles(theme => ({
  popper: {
    zIndex: 9999,
  },
  dayDropdown: {
    minWidth: 160,
  },
  dayDropdownIcon: {
    verticalAlign: 'middle',
    marginLeft: 10,
    color: theme.palette.secondary.main,
  },
  serviceBtn: {
    textTransform: 'capitalize',
    fontWeight: 400,
  },
}))

export const YourLocation = ({ name, locationId, selectedDate, changeSelectedDay }) => {
  // State used for displaying location input
  const [anchorElement, setAnchorElement] = useState(null)
  const [serviceAnchorElement, setServiceAnchorElement] = useState(null)

  const classes = useStyles()

  const nextWeek = eachDay(new Date(), addDays(new Date(), 6))

  const options = nextWeek.map((val, i) => {
    if (i === 0) {
      return {
        value: val,
        label: 'Today ' + format(val, 'M/D'),
      }
    } else {
      return {
        value: val,
        label: format(val, 'ddd M/D'),
      }
    }
  })

  return (
    <Flex>
      <Dropdown
        options={options}
        onChange={e => changeSelectedDay(format(e.value, 'YYYYMMDD'), locationId)}
        value={
          options.filter(o => {
            return format(o.value, 'YYYYMMDD') === selectedDate
          })[0]
        }
        className={classes.dayDropdown}
        controlClassName="date-dropdown__control"
        menuClassName="date-dropdown__menu"
        arrowClosed={<ExpandMoreIcon classes={{ root: classes.dayDropdownIcon }} />}
        arrowOpen={<ExpandLessIcon classes={{ root: classes.dayDropdownIcon }} />}
      />
      <div style={{ flex: '1 0 auto' }} />
      <DropdownButton
        color="primary"
        onClick={event => {
          setServiceAnchorElement(event.currentTarget)
        }}
      >
        <PersonIcon color="primary" />
        <Typography style={{ marginRight: 8, textTransform: 'none' }} variant="body1">
          Individual
        </Typography>
        <ExpandMoreIcon color="secondary" />
      </DropdownButton>
      <Popper
        anchorEl={serviceAnchorElement}
        modifiers={{
          flip: {
            enabled: false,
          },
          preventOverflow: {
            boundariesElement: 'scrollParent',
            enabled: true,
          },
        }}
        open={!!serviceAnchorElement}
        placement="bottom"
      >
        <ClickAwayListener onClickAway={() => setServiceAnchorElement(null)}>
          <Paper>
            <List>
              <ListItem button onClick={() => setServiceAnchorElement(null)}>
                <Box marginRight={3}>
                  <RadioButtonChecked color="primary" />
                </Box>
                <ListItemText>
                  <Dotdotdot clamp={1}>
                    <Typography color="primary">Individual</Typography>
                  </Dotdotdot>
                </ListItemText>
              </ListItem>
              <ListItem
                button
                onClick={() => (window.location.href = process.env.REACT_APP_GROUP_ORDER_URL)}
              >
                <Box marginRight={3}>
                  <RadioButtonUnchecked />
                </Box>
                <ListItemText>
                  <Dotdotdot clamp={1}>
                    <Typography>Group Order</Typography>
                  </Dotdotdot>
                </ListItemText>
              </ListItem>
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>

      <DropdownButton
        color="primary"
        onClick={event => {
          setAnchorElement(event.currentTarget)
        }}
      >
        <LocationOn color="primary" />
        <Typography style={{ marginRight: 8, textTransform: 'none' }} variant="body1">
          {name}
        </Typography>
        <ExpandMoreIcon color="secondary" />
      </DropdownButton>
      <Popper
        anchorEl={anchorElement}
        id="location-switcher"
        modifiers={{
          flip: {
            enabled: false,
          },
          preventOverflow: {
            boundariesElement: 'scrollParent',
            enabled: true,
          },
        }}
        open={!!anchorElement}
        placement="bottom"
        className={classes.popper}
      >
        <ClickAwayListener onClickAway={() => setAnchorElement(null)}>
          <Box width={320}>
            <Paper>
              <LocationSearchWithScripts />
            </Paper>
          </Box>
        </ClickAwayListener>
      </Popper>
    </Flex>
  )
}

YourLocation.defaultProps = {
  address: {},
}

const Flex = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and ${themeConWeb.small} {
    flex-direction: column;
    align-items: center;
    margin-bottom: calc(${themeConWeb.baseUnit} * 4);
  }
`

const DropdownButton = styled(Button)`
  align-self: flex-end;
  color: #3d4a6b;
  display: flex;

  @media screen and (min-width: 320px) and (max-width: 640px) {
    align-self: center;
  }
`

export default YourLocation
